import React from "react";
import Snippet from "../SnippetIcon/Snippet";

const SearchField = ({ label, labeling, className = "", ...restProps }) => {
  return (
    <div
      className="relative w-full max-w-field-lg md:max-w-field-search mx-auto h-10 xl:h-[42px] 2xl:h-11"
      data-admin-allow-view-only=""
    >
      {labeling && (
        <Snippet variant={"label"} label={label} star={false} />
      )}
      <div className="relative h-full w-full">
        <span className="pointer-events-none absolute left-3 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center sm:left-4">
          <i className="fi fi-rs-search text-base text-offblack" />
        </span>
        <input
          className={`input-placeholder h-full w-full rounded-field border border-solid border-mediumgray bg-mistygray pl-11 pr-3 font-inter font-normal text-offblack tp-field-focus focus:outline-none sm:pl-12 sm:pr-4 ${className}`}
          {...restProps}
          name={restProps?.name}
        />
      </div>
    </div>
  );
};

export default SearchField;
